var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"sar-symbol",style:({ height: _vm.size, width: 'auto' }),attrs:{"src":require("@/assets/sar-symbol.svg"),"alt":"SAR"}})
}
var staticRenderFns = []

export { render, staticRenderFns }